import { z } from 'zod';

import { levelEnumValidator } from '../../validators';

export const GetTopicWordsSchema = z.object({
  count: z
    .number()
    .int()
    .min(1, 'Count must be at least 1')
    .max(300, 'Count cannot exceed 300')
    .optional()
    .default(100),
  level: levelEnumValidator.optional(),
  topic: z.string().min(1, 'Topic cannot be empty.'),
});

export type IGetTopicWordsDto = z.infer<typeof GetTopicWordsSchema>;
